import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PersonalBlock } from '../../components/generaldata/generaldatapages/personal';

const PersonalPage: FC = () => {
    const {t} = useTranslation();
    const { alias } = useParams<{ alias: string }>();
    

    if (!alias) {
        return <div> alias не найден </div>;
    }

    return (
        <>
            <Helmet>
                <title>{t('titles.personnel')}</title>
            </Helmet>
            <PersonalBlock alias={String(alias)}/>
        </>
    );
};

export default PersonalPage
